import type { CapabilityBinding, ModuleMeta } from '../../core/types';
import type { EbmFieldKey } from './fields';

export const EBM_CAPABILITIES = [
  {
    key: 'base-info',
    pathPrefix: '',
    options: { nameMaxLength: 63, descriptionMaxLength: 256 },
  },
  {
    key: 'network',
    pathPrefix: 'resource.network',
    options: { showSecurityGroup: true, flatFields: true, showSubnet: false },
  },
  {
    key: 'run-policy',
    pathPrefix: '',
    options: { loadFromApi: true },
  },
  {
    key: 'image-vm',
    pathPrefix: '',
    options: {
      imageListKind: 'elasticBareMetal',
      diskSegment: 'systemDisk',
    },
  },
  {
    key: 'ebm-nodes',
    pathPrefix: '',
  },
  {
    key: 'service',
    pathPrefix: 'resource',
    options: { listSegment: 'service', requireAtLeastOne: false },
  },
  {
    key: 'dns',
    pathPrefix: 'resource.network',
  },
] as const satisfies readonly CapabilityBinding[];

export const EBM_MODULES = [
  {
    key: 'baseInfo',
    title: '基本信息',
    capabilities: [{ key: 'base-info', pathPrefix: '' }],
    fields: ['base.name', 'base.description', 'base.workspace', 'base.namespace', 'base.datacenter'],
    /** 与表单/preset 序列化路径对齐；EBM_SKU_MODULE_META 暂未挂 baseInfo 时仍保留 */
    presetCheckFields: ['name'],
  },
  {
    key: 'network',
    title: '网络设置',
    capabilities: [
      {
        key: 'network',
        pathPrefix: 'resource.network',
        options: { showSecurityGroup: true, flatFields: true, showSubnet: false },
      },
    ],
    fields: ['network.vpc', 'network.subnet', 'network.securitygroup'],
    presetCheckFields: ['resource.network.vpc.name'],
  },
  {
    key: 'systemSetting',
    title: '系统盘设置',
    capabilities: [
      { key: 'run-policy', pathPrefix: '', options: { loadFromApi: true } },
      {
        key: 'image-vm',
        pathPrefix: '',
        options: { imageListKind: 'elasticBareMetal', diskSegment: 'systemDisk' },
      },
    ],
    fields: ['runPolicy.strategy', 'disk'],
    presetCheckFields: ['runStrategy', 'systemDisk'],
    resetFieldPaths: ['runStrategy', 'systemDisk'],
  },
  {
    key: 'resource',
    title: '资源选择',
    capabilities: [{ key: 'ebm-nodes', pathPrefix: '' }],
    fields: ['ebm.resourceConfiguration'],
    presetCheckFields: ['resourceConfiguration'],
    resetFieldPaths: ['resourceConfiguration'],
  },
  {
    key: 'service',
    title: '服务配置',
    capabilities: [
      {
        key: 'service',
        pathPrefix: 'resource',
        options: { listSegment: 'service', requireAtLeastOne: false },
      },
    ],
    fields: ['service.list'],
    presetCheckFields: ['resource.network.service'],
    resetFieldPaths: ['resource.network.service'],
  },
  {
    key: 'dns',
    title: 'DNS配置',
    capabilities: [{ key: 'dns', pathPrefix: 'resource.network' }],
    fields: ['network.dns.nameservers', 'network.dns.searches', 'network.dns.options'],
    presetCheckFields: [
      'resource.network.dnsConfig.nameservers',
      'resource.network.dnsConfig.searches',
      'resource.network.dnsConfig.options',
    ],
    resetFieldPaths: ['resource.network.dnsConfig'],
  },
] as const satisfies readonly ModuleMeta<EbmFieldKey>[];

export const EBM_MODULE_MAP = Object.fromEntries(EBM_MODULES.map((item) => [item.key, item]));
